import { render, staticRenderFns } from "./offerAmountStatus.vue?vue&type=template&id=72cbf9f4"
import script from "./offerAmountStatus.vue?vue&type=script&lang=js"
export * from "./offerAmountStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports